import { useState } from "react";
import { ListItem, Typography, Box, Button, Tooltip } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Loop } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import AddOrEditBudgetModal from "./AddOrEditBudgetModal";
import { useSaveBudgetMutation } from "../../../services/queryHooks";

export default function InvestmentWalletLine({ wallet, type, period }) {
	const userCurrency = localStorage.getItem("userCurrency");
	const theme = useTheme();
	const { t } = useTranslation();

	const [isAddOrEditModalOpen, setIsAddOrEditModalOpen] = useState(false);

	const { mutate: saveBudget, isPending } = useSaveBudgetMutation();

	const handleSubmit = (data) => {
		saveBudget(data);
	};

	const balanceStyles = {
		color:
			wallet.transactionsSum >= wallet.budget
				? theme.palette.values.positive
				: theme.palette.values.negative,
	};

	return (
		<>
			<ListItem
				key={wallet._id}
				sx={{
					pl: 5.5,
					py: 0,
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<Typography variant="body1">{wallet.name}</Typography>

				<Box
					sx={{
						display: "flex",
					}}
				>
					<Typography
						variant="body1"
						sx={{
							...balanceStyles,
						}}
					>
						{wallet.transactionsSum.toFixed(2).toLocaleString()}{" "}
						{userCurrency}
					</Typography>
					<Typography
						variant="body1"
						sx={{
							ml: 0.5,
						}}
					>
						/
					</Typography>
					<Button
						color="primary"
						variant="text"
						onClick={() => setIsAddOrEditModalOpen(true)}
						sx={{ py: 0, px: 0.5, fontWeight: "normal" }}
					>
						{wallet.isBudgetRecurring ? (
							<Tooltip
								title={t("recurringBudget")}
								placement="top"
								arrow
							>
								<span>
									<Loop
										sx={{
											width: "19px",
											verticalAlign: "sub",
										}}
									/>
								</span>
							</Tooltip>
						) : null}{" "}
						<Typography variant="body1">
							{Math.abs(wallet.budget)
								.toFixed(2)
								.toLocaleString()}{" "}
							{userCurrency}
						</Typography>
					</Button>
				</Box>
			</ListItem>
			<AddOrEditBudgetModal
				isOpen={isAddOrEditModalOpen}
				onClose={() => setIsAddOrEditModalOpen(false)}
				initialData={{
					budgetId:
						wallet.budgetSource === "currentPeriod"
							? wallet.budgetId
							: "",
					categoryId: "",
					categoryName: "",
					categoryGroupId: "",
					categoryGroupName: "",
					walletId: wallet.walletId,
					walletName: wallet.name,
					date: period,
					amount: wallet.budget,
					minAmount: 0,
					maxAmount: Infinity,
					type,
					totalBudget: false,
					recurring:
						wallet.budgetSource === "currentPeriod" &&
						wallet.isBudgetRecurring === false
							? false
							: true,
				}}
				onSubmit={handleSubmit}
				isPending={isPending}
			/>
		</>
	);
}
